<template>
  <div>
    <SelectedDistrictTitle
      :district="postgres.districtname"
      :state="postgres.statename"
      :rep="rep"
      :party="party"
      :singleDistState="postgres.currentseats === 1"
      :multimember="postgres.legislatorname === 'multimember'"
    />
    <!-- <LayerToggleButton 
      :layerType="Enums.MAP_VARIABLES.DEVIATION"
      :buttonLabel="'Difference from State Average'"
    />
    <LayerToggleButton
      :layerType="Enums.MAP_VARIABLES.POPCHGPCT1019"
      :buttonLabel="'Estimated Population Change 2010-2019'"
    /> -->

    <img class="map-img" v-if="this.imgData !== null" :src="this.imgData" />
    <span class="map-img" v-if="this.imgData !== null">
      © <a href="https://www.mapbox.com/about/maps/">Mapbox</a> ©
      <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>
      <strong
        ><a href="https://www.mapbox.com/map-feedback/" target="_blank"
          >Improve this map</a
        ></strong
      >
    </span>
    <MapLegend class="data-legend" v-if="this.imgData !== null" />

    <div dark class="selected-district-container" v-show="this.dataSelected">
      <SelectedCongressDistrict
        v-if="activeDistrictType === Enums.LEG_BODY.CONGRESS"
      />
      <SelectedStateUpperDistrict
        v-if="activeDistrictType === Enums.LEG_BODY.ST_UPPER"
      />
      <SelectedStateLowerDistrict
        v-if="activeDistrictType === Enums.LEG_BODY.ST_LOWER"
      />
    </div>
  </div>
</template>
<script>
import { Enums } from "../../data/Config/Config";
import SelectedCongressDistrict from "./SelectedDistricts/SelectedCongressDistrict.vue";
import SelectedStateLowerDistrict from "./SelectedDistricts/SelectedStateLowerDistrict.vue";
import SelectedStateUpperDistrict from "./SelectedDistricts/SelectedStateUpperDistrict.vue";
import SelectedDistrictTitle from "./SelectedDistricts/SelectedDistrictTitle";
import MapLegend from "./MapLegend";
import { EventBus } from "../../data/EventBus";

//import LayerToggleButton from "../Menus/LayerToggleButton";

export default {
  name: "SelectedDataDisplay",
  props: ["imgData", "printable"],
  components: {
    SelectedCongressDistrict,
    SelectedStateLowerDistrict,
    SelectedStateUpperDistrict,
    SelectedDistrictTitle,

    //LayerToggleButton
    MapLegend,
  },
  computed: {
    rep: function () {
      if (this.activeDistrictType === Enums.LEG_BODY.CONGRESS) {
        return this.propub.name;
      }
      return this.postgres.legislatorname || "";
    },
    party: function () {
      if (this.activeDistrictType === Enums.LEG_BODY.CONGRESS) {
        return this.propub.party;
      }
      return this.postgres.partyabb || "";
    },
    propub: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.PROPUB] || {}
      );
    },

    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
    activeDistrictType: function () {
      return this.$store.getters.getDistrictType;
    },
    dataSelected: function () {
      return Object.entries(this.$store.getters.getSelectedData).length > 0;
    },
  },
  data: function () {
    return {
      Enums: Enums,
      EventBus: EventBus,
    };
  },
  watch: {},
  methods: {},
};
</script>
<style scoped>
.v-divider {
  margin-top: 10px;
}
</style>
<style>
.share-dist i {
  font-size: 1.2em;
  padding-bottom: 3px;
}

.share-dist {
  display: inline-block;
  /* margin: 5px 0; */
  font-size: 0.6em;
  position: absolute;
  bottom: -2px;
  right: 0px;
  width: 60px;
  z-index: 1;
  padding: 0;
  text-align: center;
}
.v-application .title {
  overflow: inherit;
  background: var(--powder-blue);
  /* background: var(--tan); */
  color: var(--prussian-blue);
  font-weight: 500;
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  line-height: 1.5rem;
  padding: 5px 0;
  padding-left: 45px;
}
.data-note-btn-container{
      width: 100%;
    text-align: center;
    cursor: pointer;
    padding: 5px;
    font-size: .9em;
}

.text-needtoexpand-color {
  color: #b35806 !important;
}
.text-needtoshrink-color {
  color: #1a9850;
}
.text-popdecrease-color {
  color: #e08214;
}
.text-popincrease-color {
  color: #542788;
}
.selected-district-container {
  padding: 10px;
  padding-top: 0;
}
</style>
<style scoped>
.map-img {
  max-width: 100%;
  pointer-events: all;
}
</style>
<style>
#print-container {
  pointer-events: none !important;
}
#print-container .title button {
  display: none !important;
}
#print-container .title.district-state {
  padding-left: 0px;
}

#print-container .v-tabs {
  display: none;
}

#print-container > div > .legend {
  background-color: #fff;
  border-radius: 3px;
  bottom: 0px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 10px 22px;
  position: relative;
  right: 0px;
  z-index: 1;
}

.side-menu .data-legend.legend,
.data-legend button,
.side-menu .map-img,
#print-container .share-dist,
#print-container > .legend > .slider-container,
#print-container > .legend > .slider-container *,
#print-container > .legend > button {
  display: none !important;
}
</style>